import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents";
import Table from "../../Components/Table/Table";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import styles from "./styles/post_report_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

//
import { useDispatch, useSelector } from "react-redux"; // for getting and setting data into local redux
// import { useGetAllUsersQuery } from "../../Data/services/userApi"; // get data from API Servers

import { ShimmerTable } from "react-shimmer-effects";
import GlobalStyles from "../../_global.scss";
import DeleteModal from "../../Components/Modals/DeleteModal";
import ReportComponent from "../../Components/ReportComponent/ReportComponent.js";
import {
  useGetAllReportPostsQuery,
  useUpdateReportPostMutation,
} from "../../Data/services/postReportApi.js";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner.js";

const PostReportManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  const { primaryColor } = GlobalStyles;

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");
  const [isDeleted, setIsDeleted] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const dummyData = [
    {
      id: 1,
      reporter: {
        userName: "UserName",
        userTag: "@user1234",
        userImage: "images/profile_image.jpeg",
      },
      reportee: {
        post: {
          postTitle: "Devil Times Five (a.k.a. Peopletoys)",
          postCreated: "12/02/2026",
          user: {
            userName: "adranfield",
            userTag: "adranfield@1234",
            userImage: "images/profile_image.jpeg",
          },
        },
        message:
          "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using.",
        reportDate: "12/02/2025",
      },
    },
    {
      id: 2,
      reporter: {
        userName: "UserName 2",
        userTag: "@user1234",
        userImage: "images/profile_image.jpeg",
      },
      reportee: {
        post: {
          postTitle: "Devil Times Five (a.k.a. Peopletoys) Second",
          postCreated: "12/02/2026",
          user: {
            userName: "adranfield 2",
            userTag: "adranfield@1234",
            userImage: "images/profile_image.jpeg",
          },
        },
        message:
          "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using.",
        reportDate: "12/02/2025",
      },
    },
    {
      id: 3,
      reporter: {
        userName: "UserName 3",
        userTag: "@user1234",
        userImage: "images/profile_image.jpeg",
      },
      reportee: {
        post: {
          postTitle: "Devil Times Five (a.k.a. Peopletoys) Third",
          postCreated: "12/02/2026",
          user: {
            userName: "adranfield 3",
            userTag: "adranfield@1234",
            userImage: "images/profile_image.jpeg",
          },
        },
        message:
          "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using.",
        reportDate: "12/02/2025",
      },
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllReportPostsQuery({ refetchOnMountOrArgChange: true });
  const postData = data?.data;

  // var postData = useSelector((state) => state?.postReport?.data);

  useEffect(() => {
    setRowData(postData?.filter((x) => x.instance_type === "post"));
  }, [postData]);


  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const [updateStatus] = useUpdateReportPostMutation();

  const deleteData = async (row) => {
    // console.log(editedData.slug);
    // console.log(row);
    const modifiedData = {
      // slug: editedData.slug,
      id: row.id,
      status: "resolved",
    };
    // console.log(modifiedData);
    try {
      const { data } = await updateStatus(modifiedData);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  const handleChangeBlockStatus = async (row) => {
    // console.log(row.slug);

    const modifiedData = {
      slug: row.slug,
      status: "Block",
    };
    // console.log(modifiedData);
    try {
      const { data } = await updateStatus(modifiedData);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  const handleShowDeleteModal = (row) => {
    // console.log(row);
    // debugger;
    setEditedData(row);
    handleDeleteModalOpen();
  };

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(Array.isArray(data?.data) ? data.data : []);
      setDataFetched(true);
    }
  }, [data]);

  function indication() {
    return <ShimmerTable row={5} col={1} />;
  }

  const columns = [
    {
      headerStyle: {
        width: "80%",
        display: "none",
      },
      styles: {
        width: "80%",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row) {
          return (
            <ReportComponent
              onClickDeleteButton={deleteData}
              onClickBlockButton={handleChangeBlockStatus}
              data={row}
              isDeleted={isDeleted}
              setIsDeleted={setIsDeleted}
            />
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          data={editedData}
          onDelete={deleteData}
        />
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Post Report Management"} classes="primary-text" />
        </div>
      </div>

      <div className={styles.mainTable}>
      {!dataFetched ? (
          <CustomSpinner />
        ) : (
          <Table
            data={rowData ?? []}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          />
        )}
      </div>
    </div>
  );
};

export default PostReportManagementScreen;
